module.exports = __webpack_public_path__ + "img/hobby-clear.de123058.png";